import shaw from '../../../src/tool/BaseXJT.js'
export default {
  /**
   * 订单支付服务类型
   * @Author 肖家添
   * @Date 2019/10/21 12:32
   */
  orderPaymentServiceType: {
    /**
     * 二维码支付
     */
    PAYMENT_TYPE_4: 4,
    /**
     * 线下转账
     */
    PAYMENT_TYPE_5: 5
  },

  /**
   * 订单状态
   * @Author 肖家添
   * @Date 2019/10/16 16:10
   */
  orderStatus: {
    /**
     * 待确认
     */
    ORDER_STATUS_0: 0,
    /**
     * 待支付
     */
    ORDER_STATUS_1: 1,
    /**
     * 支付成功
     */
    ORDER_STATUS_2: 2,
    /**
     * 长时间未支付
     */
    ORDER_STATUS_3: 3,
    /**
     * 已取消
     */
    ORDER_STATUS_4: 4,
    /**
     * 退款中
     */
    ORDER_STATUS_5: 5,
    /**
     * 退款中
     */
    ORDER_STATUS_6: 6,
    /**
     * 退款失败
     */
    ORDER_STATUS_7: 7,
    /**
     * Wap投保中的状态，表示订单未可显示
     */
    ORDER_STATUS_8: 8,
    /**
     * 积分支付
     */
    ORDER_STATUS_9: 9,
    /**
     * 领取成功(已支付)
     */
    ORDER_STATUS_10: 10,
    /**
     * 支付成功积分不够无法投保
     */
    ORDER_STATUS_11: 11,
    /**
     * 积分 + 支付
     */
    ORDER_STATUS_12: 12,
    /**
     * 正在核对转账流水号
     */
    ORDER_STATUS_13: 13,
    /**
     * 保全退款结算完成
     */
    ORDER_STATUS_14: 14,
    /**
     * 顺丰专用不明确支付流程
     */
    ORDER_STATUS_21: 21,
  },

  /**
   * 支付业务类型
   * @Author 肖家添
   * @Date 2020/3/25 18:03
   */
  payDoComplexFormType: {
    /**
     * 投保订单
     */
    FORM_TYPE_10001: 10001,
    /**
     * 保全订单
     */
    FORM_TYPE_100010: 100010,
    /**
     * VIP会员时间购买
     */
    FORM_TYPE_10004: 10004,
    /**
     * 一对一咨询购买
     */
    FORM_TYPE_10005: 10005,
    /**
     * 课堂购买
     */
    FORM_TYPE_10006: 10006,
    /**
     * 资讯购买
     */
    FORM_TYPE_10009: 10009
  },

  /**
   * 订单支付前作数据校验 -> 响应编码处理
   * @Author 肖家添
   * @Date 2019/10/14 21:09
   */
  orderPaymentBefore_codeHandler(data) {
    const error_codes = {
      E0001: "订单不存在！",
      E0002: "当前产品已下架，请重新选择产品投保！",
      E0003: "当前订单已经支付！",
      E0004: "当前订单已经不可支付！！",
      E0005: "订单起保时间小于等于当前时间！",
      E0006: "系统维护中，请于00:00之后再试！",
    };
    let msg = data.msg,
    errorMsgForCode = error_codes[msg];
    errorMsgForCode = shaw.changeIsNilVal(errorMsgForCode, msg);

    return errorMsgForCode;
  },
}



//////////////////
// WEBPACK FOOTER
// ./static/js/order/orderHelper.js
// module id = null
// module chunks = 